import ConfirmationModalBase from '@/components/ui/confirmation-modal';
import NotificationModalBase from '@/components/ui/notification-modal';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ConfirmModalProvider, useConfirmModal } from '@/hooks/useConfirmModal';
import {
  NotificationModalProvider,
  useNotificationModal,
} from '@/hooks/useNotificationModal';

const ConfirmationModal = () => {
  const { confirmModal, hideConfirmModal } = useConfirmModal();

  return (
    <ConfirmationModalBase
      isOpen={confirmModal.isOpen}
      onClose={hideConfirmModal}
      onConfirm={confirmModal.onConfirm}
      title={confirmModal.title}
      description={confirmModal.description}
      variant={confirmModal.variant}
      confirmText={
        confirmModal.variant === 'destructive'
          ? 'Delete'
          : confirmModal.confirmText || 'Confirm'
      }
      cancelText="Cancel"
    />
  );
};

const NotificationModal = () => {
  const { notificationModal, hideNotificationModal } = useNotificationModal();

  return (
    <NotificationModalBase
      content={notificationModal.content}
      isOpen={notificationModal.isOpen}
      onClose={hideNotificationModal}
      title={notificationModal.title}
      message={notificationModal.message}
      type={notificationModal.type}
    />
  );
};

const OverlayProvider = ({ children }) => {
  return (
    <TooltipProvider>
      <ConfirmModalProvider>
        <NotificationModalProvider>
          {children}
          <ConfirmationModal />
          <NotificationModal />
        </NotificationModalProvider>
      </ConfirmModalProvider>
    </TooltipProvider>
  );
};

export default OverlayProvider;
